export default {
  logea() {
    console.log("holi");
  }
}